(ns app.login.styles
  (:require-macros)
  (:require [garden.stylesheet :refer [at-media]]
            [spade.core   :refer [defclass]]))


(defclass pwd-field
  []
  {:position "relative"
   :width "100%"})


(defclass input-hint
  []
  {:position "absolute"
   :top "-150%"
   :left "0"
   :border-radius "2px"
   :background "#293845"
   :box-shadow "0 2px 8px rgb(0 0 0 / 25%)"
   :font-size "13px"
   :font-weight "500"
   :line-height "18px"
   :padding "4px 8px"
   :color "#FFFFFF"}
  [:&:after
   {:position "absolute"
    :bottom "-5px"
    :left "26px"
    :content "' '"
    :width "0"
    :height "0"
    :border-left "5px solid transparent"
    :border-right "5px solid transparent"
    :border-top "5px solid #293845"}])

(defclass login-border
  []
  {:border "none"
   :border-top "2px solid"
   :border-color :theme/*greyBorderColor*
   :width "40%"})
